import { render, staticRenderFns } from "./AdsPutInKey.vue?vue&type=template&id=6c9a9d85"
import script from "./AdsPutInKey.vue?vue&type=script&lang=js"
export * from "./AdsPutInKey.vue?vue&type=script&lang=js"
import style0 from "./AdsPutInKey.vue?vue&type=style&index=0&id=6c9a9d85&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports